import { ObjID } from './../../../model/id-manager';
import { Project } from 'app/model/project';
import { FeatureData } from './../../../model/project';
import { Preset, PresetData, AttributeFeatureType, AttributeInfo, ConfigAttribute } from './../../../types/project-config';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-preset-workspace',
  templateUrl: './preset-workspace.component.html',
  styleUrls: ['./preset-workspace.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PresetWorkspaceComponent implements OnInit {

  private _ready: boolean = false;
  @Output()
  presetChange = new EventEmitter<Preset>();

  public set name(n: string) {
    if (!this._preset) return;
    if (this._preset.label !== n) {
      this._preset.label = n;
      this.NotifyListeners();
    }
    this.Refresh();
  }

  public get name(): string {
    if (!this._preset) return '';
    return this._preset.label;
  }

  private _project?: Project;
  @Input()
  public set project(prj: Project | undefined) {
    this._project = prj;
    this.cdr.markForCheck();
    this.Refresh();
  }
  public get project(): Project | undefined {
    return this._project;
  }

  constructor(private cdr: ChangeDetectorRef) { }

  _preset?: Preset;
  @Input()
  set preset(pre: Preset | undefined) {
    this._preset = pre;
    if (this._preset && !this._preset.data) {
      this._preset.data = {};
    }
    this.Refresh();
  }
  get preset(): Preset | undefined {
    return this._preset;
  }

  get presetFeatureType(): AttributeFeatureType | undefined {
    if (!(this.project && this._preset)) return undefined;
    const type: AttributeFeatureType | false = this.project.GetFeatureType(this._preset.id);
    return (type === false) ? undefined : type as AttributeFeatureType;
  }
  get presetData(): FeatureData {
    if (!this._preset) {
      return {};
    }
    return this._preset.data as FeatureData;
  }

  ngOnInit(): void {
    this._ready = true;

  }
  NotifyListeners() {
    this.presetChange.emit(this._preset);
  }
  Refresh() {
    if (this._ready === false) return;
    this.cdr.detectChanges();
  }

}
